<template>
  <div
    class="the-submenu"
  >
    <nav class="the-submenu__content-wrapper">
      <span class="the-submenu__root-link-wrapper">
        <a
          :href="root.path"
          :title="root.name"
          class="the-submenu__link the-submenu__link--root"
        >
          {{ root.name }}
        </a>

        <span
          v-if="urls.length"
          class="the-submenu__menu"
          @click="toggleMenu"
        >
          Menu

          <z-icon
            size="small"
            class="the-submenu__arrow"
            :icon="['fas', 'chevron-down']"
          />
        </span>
      </span>

      <div>
        <ul
          v-show="showMenu"
          class="the-submenu__list"
        >
          <li
            v-for="url in urls"
            :key="url.name"
            class="the-submenu__line"
          >
            <z-link
              :tag="linkOrButton(url)"
              :href="url.path"
              :class="{ 'the-submenu__link--active': url.active }"
              :target=" url.targetBlank ? '_blank' : '_self' "
              class="the-submenu__link"
              @click="() => toggleDropdown(url)"
            >
              {{ url.name }}
              <z-icon
                v-if="url.type === 'multiple'"
                class="the-submenu__arrow"
                size="small"
                :icon="['fas', 'chevron-down']"
              />
            </z-link>

            <div>
              <ul
                v-show="dropdownController[url.name]"
                v-if="url.type === 'multiple'"
                class="the-submenu__content"
              >
                <li
                  v-for="value in url.values"
                  :key="value.name"
                  class="the-submenu__list-item"
                >
                  <a
                    :href="value.path"
                    :class="{ 'submenu__link--active': value.active }"
                    :target="value.targetBlank ? '_blank' : '_self'"
                    class="the-submenu__link"
                    @click="() => toggleDropdownSubmenu(value)"
                  >
                    <z-icon
                      class="the-submenu__arrow-before"
                      size="small"
                      :icon="['fas', 'chevron-right']"
                    />

                    <span class="the-submenu__item-text">
                      {{ value.name }}
                    </span>
                  </a>

                  <div>
                    <ul
                      v-show="subDropdownController[value.name]"
                      v-if="value.type === 'multiple'"
                      class="the-submenu__content submenu__content--sub"
                    >
                      <li
                        v-for="subvalue in value.values"
                        :key="subvalue.name"
                        class="the-submenu__list-item"
                      >
                        <a
                          :href="subvalue.path"
                          class="the-submenu__link submenu__link--sub"
                        >
                          <z-icon
                            class="the-submenu__arrow-before"
                            size="small"
                            :icon="['fas', 'chevron-right']"
                          />

                          <span class="the-submenu__item-text">
                            {{ subvalue.name }}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>

export default {
  name: 'TheSubmenu', // eslint-disable-line vue/multi-word-component-names
  props: {
    root: {
      type: Object,
      required: true,
    },
    urls: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      dropdownController: {},
      subDropdownController: {},
      showMenu: false,
    }
  },
  methods: {
    toggleDropdown (url) {
      this.dropdownController = {
        [url.name]: !this.dropdownController[url.name],
      }

      this.subDropdownController = {}
    },
    toggleMenu () {
      this.showMenu = !this.showMenu

      if (!this.showMenu) {
        this.dropdownController = {}
      }
    },
    toggleDropdownSubmenu (url) {
      this.subDropdownController = {
        [url.name]: !this.subDropdownController[url.name],
      }
    },
    linkOrButton (url) {
      if (url.type === 'multiple' || !url.path) return 'button'
      return 'a'
    },
  },
}
</script>

<style lang="scss">
.the-submenu {
  background-color: var(--color-interactive-000);
  display: flex;
  justify-content: center;
  user-select: none;
  width: 100%;
}

.the-submenu__content-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;

  @media (min-width: $breakpoint-desktop) {
    flex-direction: row;
    width: $breakpoint-desktop-large;
  }
}

.the-submenu__root-link-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-width: 0;
}

.the-submenu__link {
  align-items: center;
  color: var(--color-interactive-500);
  display: flex;
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-medium);
  padding: var(--unit-0200) var(--unit-0400);
  text-decoration: none;
  width: 100%;

  &:visited,
  &:hover {
    background-color: var(--color-interactive-100);
  }

  &:active {
    background-color: var(--color-interactive-100);
    color: var(--color-interactive-500);
  }
}

.the-submenu__link--active,
.the-submenu__button--active {
  background-color: var(--color-interactive-100);
}

.the-submenu__button {
  align-items: center;
  background-color: transparent;
  border: none;
  color: var(--color-interactive-500);
  display: flex;
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-medium);
  padding: var(--unit-0200) var(--unit-0400);
  text-decoration: none;
  width: 100%;

  &:active,
  &:hover {
    background-color: var(--color-interactive-100);
  }
}

.the-submenu__link--root {
  font-weight: var(--font-weight-bold);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: $breakpoint-phone) {
    display: block;
  }

  @media (min-width: $breakpoint-tablet) {
    height: 100%;
  }
}

.the-submenu__link--sub {
  @media (max-width: $breakpoint-phone) {
    padding-left: var(--unit-0600);
  }
}

.the-submenu__content {
  background-color: var(--color-interactive-000);
  padding-left: 0;
  position: relative;
  transition: max-height 0.1s ease-in-out;

  @media (min-width: $breakpoint-desktop) {
    position: absolute;
    z-index: 1;
  }
}

.the-submenu__content--sub {
  @media (min-width: $breakpoint-desktop) {
    left: 100%;
    top: 0;
  }
}

.the-submenu__list-item {
  list-style: none;
  min-width: 160px;
  position: relative;
}

.the-submenu__menu {
  align-items: center;
  color: var(--color-interactive-500);
  display: flex;
  flex-shrink: 0;
  font-size: var(--font-size-medium);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-size-extra-large);
  padding: var(--unit-0300) var(--unit-0200);

  @media (min-width: $breakpoint-desktop) {
    display: none;
  }
}

.the-submenu__arrow {
  margin-left: var(--unit-0200);
}

.the-submenu__arrow-before {
  margin-right: var(--unit-0200);
}

.the-submenu__list {
  background-color: var(--color-interactive-000);
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  padding-left: 0;

  @media (min-width: $breakpoint-desktop) {
    background-color: transparent;

    /* its important because it needs to override an transition default style */
    display: flex !important; /* stylelint-disable-line declaration-no-important */
    height: auto;
  }
}

.the-submenu__line {
  white-space: nowrap;
}
</style>
